export default __webpack_public_path__ + "static/signature-m-c44cf4a1e5dcfc3452959343cac39e8f.png";